import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
import SystemModel from '/chat/src/redux/model/system/model';

import FaqImage from '/chat/src/components/SVGImages/Faq'

class FaqButton extends Component {
    render() {

        let defaultStyle = style.NormalFaq
        if(this.props.isMobile)  defaultStyle = style.MobileFaq
        return (
            <div
            onClick={()=> {
                this.props.dispatch(SystemModel.setRoute('Faq'))}
            }
            className={defaultStyle}>
                 <FaqImage color='white' width='40' height='30'/>
            </div>
        );
    }
}

export default connect((state) => {
    return {
        isMobile: SystemModel.isMobile(state)
    }
})(FaqButton);



// WEBPACK FOOTER //
// ./components/Buttons/FaqButton/index.js